<template>
    <!-- 这是一个伪组件，仅在设计时用于显示在设计面板的占位组件，实际运行时会被替换掉 -->
    <!-- 组件定义时指定了 element 为 slot，所以运行时将被替换为 vue 的 slot -->
    <div class="tw-slot">
        <!-- 插槽的默认内容 -->
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'tw-slot'
}
</script>

<style>

</style>